import axios, { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import banksData from './bank.json';
import citiesData from './cities.json';
import contextData from './context.json';
import contractsData from './contracts.json';
import countriesData from './countries.json';
import departmentsData from './departments.json';
import housingsData from './housings.json';
import insuranceData from './insurances.json';
import maritalsData from './maritals.json';
import professionsData from './professions.json';
import scoreData from './score.json';
import sectorsData from './sectors.json';

export function axiosMock(): AxiosInstance {
  const axiosMock = axios.create({
    baseURL: (window as unknown as WindowWithEnv)._env_.msHostname,
    headers: { keyId: (window as unknown as WindowWithEnv)._env_.keyId || '' },
  });

  const mock = new MockAdapter(axiosMock, { delayResponse: 400 });

  mock.onGet('/referential/maritals').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, maritalsData.maritals]);
      }, 1000);
    });
  });

  mock.onGet('/referential/countries').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, countriesData.countries]);
      }, 1000);
    });
  });

  mock.onGet('/referential/departments').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, departmentsData.departments]);
      }, 1000);
    });
  });

  mock.onGet(/referential\/departments\/\d+\/cities/).reply((config) => {
    const dep = config.url?.substring(24, 26);
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, citiesData.cities.filter((c) => c.department === dep)]);
      }, 1000);
    });
  });

  mock.onGet(/referential\/localities\/\d+/).reply((config) => {
    const dep = config.url?.substring(23, 25);
    return new Promise(function (resolve) {
      setTimeout(function () {
        if (dep === '11') resolve([400, {}]);
        else if (dep === '97')
          resolve([
            422,
            [
              {
                error: '422',
                errorDescription: 'DOM-TOM zip code are not supported, zipcode : 97100',
                additionalInformation: {
                  zipcode: '971',
                  contact: '05 90 32 60 62',
                  name: 'la Guadeloupe',
                  url: 'https://www.credit-moderne.com/guadeloupe/',
                },
              },
            ],
          ]);
        else resolve([200, citiesData.cities.filter((c) => c.department === dep)]);
      }, 1000);
    });
  });

  mock.onGet('/referential/residentials').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, housingsData.housings]);
      }, 1000);
    });
  });

  mock.onGet('/referential/sectors').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, sectorsData.sectors]);
      }, 1000);
    });
  });
  mock.onGet('/referential/contracts').reply(() => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, contractsData.contracts]);
      }, 1000);
    });
  });

  mock.onGet(/\/referential\/sectors\/(.*?)\/professions/).reply((config) => {
    const sectorCode = config.url?.substring(20, 23);
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, professionsData.professions.filter((c) => c.sector === sectorCode)]);
      }, 1000);
    });
  });

  // patch mocks
  mock.onPatch(new RegExp(`subscriptions/*`)).reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([204, {}]);
      }, 1000);
    });
  });

  mock.onGet(/\/subscriptions\/(.*?)\/response/).reply(() => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([204, scoreData]);
      }, 3000);
    });
  });

  mock.onGet(/\/subscriptions\/(.*?)\/insurances/).reply(() => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, insuranceData]);
      }, 2000);
    });
  });

  mock.onGet('/referential/banks').reply(({}) => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, banksData.banks]);
      }, 1000);
    });
  });

  mock.onGet(/\/subscriptions\/(.*?)\/context/).reply(() => {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve([200, contextData]);
      }, 1000);
    });
  });

  return axiosMock;
}
